module.exports = __webpack_public_path__ + "static/media/vacuumCleanerIcon.7bd6984d.svg";